export const createPreviewProps = (merchantPageId, data) => {
    if (!merchantPageId || !data)
        return;
    const page = data.pages.find((page) => page.id === merchantPageId);
    if (!page)
        return;
    const business = data.businesses.find((business) => business.cms.find((cms) => cms.merchantPageId === merchantPageId));
    if (!business)
        return;
    const cms = business.cms.find((cms) => cms.merchantPageId === merchantPageId);
    if (!cms)
        return;
    return {
        pageTitle: page.name,
        pageDescription: 'Facebook Page',
        pageFooter: `ID: ${page.id}`,
        commerceName: cms.name,
        commerceDescription: 'Merchant Commerce',
        commerceFooter: `ID: ${cms.id}`,
        image: page.pictureUrl,
    };
};
